/*jshint esversion: 6 */

import $ from 'jquery';
import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

let $headerSlider =  $('.intro-carousel');
let $headerSliderInner = $('.intro-carousel__items');

function showCurrentContent() {
  let $slide = $headerSliderInner.find('.slick-current');
  let $content = $slide.find('.intro-carousel-item__text-wrap');
  $headerSlider.find('.intro-carousel__content__text-wrap').html($content.html());
  $headerSlider.find('.intro-carousel__content__text-wrap').fadeIn();
}

function introCarousel() {

  console.log('init');

  $headerSliderInner.on('beforeChange', (event, slick, currentSlideIndex) => {
    $headerSlider.find('.intro-carousel__content__text-wrap').fadeOut(120);
  });

  $headerSliderInner.on('afterChange', (event, slick, currentSlideIndex) => {
    showCurrentContent();
  });

  $headerSliderInner.slick({
    infinite: true,
    adaptiveHeight: false,
    autoplay: true,
    fade: false,
    // nextArrow: '',
    // prevArrow: '',
    pauseOnHover: false,
    dots: true,
    appendDots: $('.intro-carousel__content__inside'),
    appendArrows: $('.intro-carousel__content'),
    speed: 500,
    autoplaySpeed: 5000,
  });

  showCurrentContent();
}

export default introCarousel;